import React, { useState } from "react";
import ButtonBase from "@material-ui/core/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  IconButton,
  Button,
  DialogActions,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Box,
} from "@material-ui/core";
import MuiTable from "@material-ui/core/Table";
import { useProcedureResultView } from "../testCommunication/common/testQueries";
import {
  useAddNoteToResult,
  useRetestProcedure,
  useReviewProcedure,
  useUpdateFlag,
} from "./dataEgressMutations";
import { ErrorMessage } from "../common/ErrorMessage";
import { ThreadedCreator } from "../common/threadedViewer/threadedCreator";
import { useDefaultColumn, generalFilter } from "../../util/filter";
import { useTable, useFilters, useSortBy } from "react-table";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useView } from "./dataEgressQueries";
import CachedIcon from "@material-ui/icons/Cached";
import {
  useTestPermissions,
  useTestPermissionsVerification,
} from "../projectManagement/projectQueries";
import { ConfirmationDialog } from "../common/ConfirmationDialog";
import { useFetchContext } from "../common/FetchContext";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";
import { processErrorOnMutation } from "../../util/errorMessaging";
import { useAuthContext } from "../common/AuthContext";
import { useHistory } from "react-router-dom";
import { TravelerModalButton } from "./TravelerModalButton";
import { VisualizerNotesModal } from "./VisualizerNotesModal";
import { LSDBCoreTable } from "../common/LSDBCoreTable";
import { StepResultNotes } from "../projectManagement/components/virtualTraveler/StepResultNotes";
import { formatDate } from "../common/formatDate";
import { getTheme } from "../common/getLocalTheme";
import { DampHeatview } from "./DampHeatview";
import { ThermalCyclingView } from "./Thermalview";
import { CIDTestView } from "./CIDTestView";
import { Letidview } from "./Letidview";
import { PIDTestView } from "./PIDTestView";
import { HailTestView } from "./HailTestview";
import { UVIDTestView } from "./UVIDTestview";
import { HumidityFreezeTestView } from "./HumidityFreezeTestView";
import { DMLview } from "./DMLview";
import { SMLview } from "./SMLview";
import FileDownloadIcon from "@material-ui/icons/GetApp";

export const StressDataModal = ({
  id,
  name,
  disposition,
  dispositionPassedId,
  open_notes,
  has_notes,
  isComments,
  onOpenNotes,
}: {
  id: any;
  name: any;
  disposition: any;
  dispositionPassedId?: any;
  open_notes: any;
  has_notes: any;
  isComments?: any;
  onOpenNotes?: any;
}) => {
  const history = useHistory();
  const { mutateAsync: mutateRetestProcedure } = useRetestProcedure();
  const { mutateAsync: mutateReviewProcedure } = useReviewProcedure();
  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();
  const { dispatch } = useAuthContext();

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [procedureResultData, setProcedureResultData] = React.useState([]);
  const [confirmationDialogRetestOpen, setConfirmationDialogRetestOpen] =
    React.useState(false);
  const [confirmationDialogApproveOpen, setConfirmationDialogApproveOpen] =
    React.useState(false);
  const [procedureChecked, setProcedureCheck] = React.useState(false);
  const theme = useTheme();
  const defaultColumn = useDefaultColumn();
  const { mutateAsync: mutateNote } = useAddNoteToResult();
  const NOT_AVAILABLE = "N/A";

  const [downloading, setDownloading] = React.useState(false);

  // PDF Viewer State
  // PDF Viewer State
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [viewingFileType, setViewingFileType] = useState<"run" | "log" | null>(
    null,
  );

  // File List Dialog State
  const [fileListOpen, setFileListOpen] = useState(false);
  const [activeFilesList, setActiveFilesList] = useState<string[]>([]);
  const [activeFileTitle, setActiveFileTitle] = useState("");
  const [viewingRun, setViewingRun] = useState<string | null>(null);
  const [downloadingRun, setDownloadingRun] = useState<string | null>(null);
  const [activeViewingFile, setActiveViewingFile] = useState<any>(null);

  const [flagChecked, setFlagCheck] = React.useState(false);
  const [flagDialog, setFlagDialog] = React.useState(false);
  const { mutateAsync: mutateUpdateFlag } = useUpdateFlag();
  const submitFlagUpdate = async () => {
    try {
      if (flagChecked) {
        await mutateUpdateFlag({
          authAxios,
          id: procedureData.id,
          final_result: false,
        });
        setFlagCheck(false);
      } else {
        await mutateUpdateFlag({
          authAxios,
          id: procedureData.id,
          final_result: true,
        });
        setFlagCheck(true);
      }
      toast.success("Request Submited Successfully");
      setFlagDialog(false);
      queryClient.invalidateQueries("travelerResults");
    } catch (error) {
      toast.error("Request Submition Failed");
      setFlagDialog(false);
    }
  };

  const {
    data: procedureData,
    error: procedureError,
    isLoading: isLoadingProcedure,
    isError: isErrorProcedure,
    isSuccess: isSuccessProcedure,
  } = useView(id, isOpen);

  const listProcedures = [
    "Light Soak >10 kWh/m²",
    "Light Soak >10 kWh/m²",
    "Light Soak >40 kWh/m²",
    "High-Temp Light Soak 168",
    "Light Soak >60 kWh/m²",
    "Light Soak >20 kWh/m²",
    "Light Soak 0.1-0.5 kWh/m²",
  ];
  const testTypes = [
    "damp_heat",
    "thermal_cycling",
    "cid_test",
    "letid_test",
    "light_soak",
    "pid_test",
    "hail_test",
    "uvid_test",
    "humidity_freeze",
    "dml",
    "sml",
  ];

  const { data: permission, isLoading: isLoadingPermission } =
    useTestPermissionsVerification(id, isOpen);

  React.useEffect(() => {
    if (isSuccessProcedure) {
      procedureData.final_result ? setFlagCheck(true) : setFlagCheck(false);
      setProcedureResultData(procedureData.step_results);
      if (listProcedures.includes(procedureData.procedure_definition_name)) {
        setProcedureCheck(true);
        console.log("procedureCheck", procedureChecked);
      }
    }
  }, [isSuccessProcedure, procedureData]);

  const columns = React.useMemo(
    () => [
      { Header: "ID", id: "id", accessor: "id", filter: generalFilter },
      { Header: "Step Name", accessor: "name", filter: generalFilter },
      {
        Header: "Start Date/Time",
        accessor: (row: any) =>
          row.measurement_results[0].result_datetime
            ? formatDate(row.measurement_results[0].result_datetime)
            : NOT_AVAILABLE,
        filter: generalFilter,
      },
      {
        Header: "Metadata",
        accessor: (row: any) => {
          let result = "";
          let resultType =
            row.measurement_results[0].measurement_result_type_field;
          resultType === "result_datetime"
            ? (result = "Date (see Start Date/Time)")
            : (result = row.measurement_results[0][resultType]);
          return result;
        },
      },
      {
        Header: "Asset",
        id: "Asset Name",
        accessor: "measurement_results[0].asset_name",
      },
      {
        id: "User Name",
        Header: "User",
        accessor: "measurement_results[0].username",
        filter: generalFilter,
      },
      {
        id: "View",
        Header: "View",
        accessor: "notes",
        disableFilters: true,
        Cell: ({ row }: any) => {
          console.info(row.value);
          if (
            row.values.name == "Test Pause" ||
            row.values.name == "Test Resume"
          ) {
            return (
              <StepResultNotes
                id={row.values.id}
                name={row.values.name}
              ></StepResultNotes>
            );
          }
        },
      },
    ],
    [],
  );

  if (isLoadingProcedure || isLoadingPermission) {
    return (
      <div style={theme.containerMargin}>
        <Grid>
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (isErrorProcedure) {
    return <ErrorMessage error={procedureError} />;
  }

  const toggleOpenState = () => {
    setIsOpen((value) => !value);
  };

  const submitVerification = async (result: boolean) => {
    if (result) {
      try {
        await mutateReviewProcedure({
          authAxios,
          disposition: dispositionPassedId,
          procedure_result: procedureData.id,
        });
        toast.success("Colorimeter Test Review Approved");
        setConfirmationDialogApproveOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      } catch (error) {
        toast.error("Error while approving Colorimeter Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogApproveOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      }
    } else {
      try {
        await mutateRetestProcedure({
          authAxios,
          procedure_result: procedureData.id,
        });
        toast.success("Colorimeter Test Review was sent for retesting");
        setConfirmationDialogRetestOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      } catch (error) {
        toast.error("Error while retesting Colorimeter Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogRetestOpen(false);
        setIsOpen(false);
        queryClient.invalidateQueries("verify_data");
        queryClient.invalidateQueries("travelerResults");
      }
    }
  };

  const handleOpenFileList = (files: any[] | string[], title: string) => {
    if (!files || files.length === 0) {
      toast.error("No Files Available.");
      return;
    }
    setActiveFilesList(files);
    setActiveFileTitle(title);
    setFileListOpen(true);
  };

  const handleViewFile = async (runFileObj: any, runKey: string) => {
    try {
      setActiveViewingFile(runFileObj); // Save reference for header download

      const fileUrl =
        typeof runFileObj === "string"
          ? runFileObj
          : runFileObj?.stress_download_url;
      if (!fileUrl) {
        toast.error("No file download URL available.");
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found.");
        return;
      }

      setViewingRun(runKey);
      setPdfViewerOpen(true);
      setIsPdfLoading(true);

      const response = await fetch(fileUrl, {
        method: "GET",
        headers: { Authorization: `Token ${token}` },
      });

      if (!response.ok) {
        throw new Error(
          `Fetch failed: ${response.status} ${response.statusText}`,
        );
      }

      const contentType =
        response.headers.get("content-type") || "application/pdf";
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(
        new Blob([blob], { type: contentType }),
      );

      setPdfBlobUrl(blobUrl);
    } catch (error) {
      console.error("View error:", error);
      toast.error("Failed to load file.");
      setPdfViewerOpen(false);
    } finally {
      setIsPdfLoading(false);
      setViewingRun(null);
    }
  };

  const handleClosePdfViewer = () => {
    setPdfViewerOpen(false);

    if (pdfBlobUrl) {
      window.URL.revokeObjectURL(pdfBlobUrl);
    }

    setPdfBlobUrl(null);
    setActiveViewingFile(null);
  };

  const handleDownload = async (
    runFileObj: any,
    runKey: string,
  ): Promise<void> => {
    try {
      const fileUrl =
        typeof runFileObj === "string"
          ? runFileObj
          : runFileObj?.stress_download_url;
      const fileName =
        typeof runFileObj === "object" ? runFileObj?.filename : "download.pdf";

      if (!fileUrl) {
        toast.error("No file available for download.");
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token not found.");
        return;
      }

      setDownloadingRun(runKey);

      const response = await fetch(fileUrl, {
        method: "GET",
        headers: { Authorization: `Token ${token}` },
      });

      if (!response.ok) {
        throw new Error(
          `Download failed: ${response.status} ${response.statusText}`,
        );
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || `run-file-${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl);
      toast.success("File downloaded successfully.");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download file.");
    } finally {
      setDownloadingRun(null);
    }
  };

  return (
    <React.Fragment>
      <TravelerModalButton
        disposition={disposition}
        name={name}
        handleClose={toggleOpenState}
        open_notes={open_notes}
        has_notes={has_notes}
        type="stress"
        isComments={isComments}
        onOpenNotes={onOpenNotes}
      />
      <Dialog open={isOpen} onClose={toggleOpenState} fullWidth maxWidth="lg">
        <DialogTitle id="scroll-dialog-title">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={8}>
              <Typography variant="h6">{`Stress Data - ${name}`};</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" display="inline">
                Flag Result:
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <ThreadedCreator
                id={id}
                noteType={3}
                model={"procedure"}
                invalidate={[""]}
                typeable={false}
              />
            </Grid>
            <Grid item xs={1}>
              <VisualizerNotesModal
                procedureId={id}
                name={`Stress Data Review - ${name}`}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={toggleOpenState}>
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              {procedureData?.test_type === testTypes[4] && (
                // light
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2021 MQT19/ IEC 61215:2016
                  MQT19
                </Typography>
              )}
              {procedureData?.test_type === testTypes[0] && (
                // DH
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2016 MQT13/ IEC 61215:2021
                  MQT13/IEC 61730:2016 MST53
                </Typography>
              )}
              {procedureData?.test_type === testTypes[1] && (
                // TC
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2016 MQT11/ IEC 61215:2021
                  MQT11/ IEC 61730:2016 MST51
                </Typography>
              )}
              {procedureData?.test_type === testTypes[3] && (
                // letid
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2018/ IEC TS 63342.0.1-2022
                </Typography>
              )}
              {procedureData?.test_type === testTypes[5] && (
                // pid
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 62804-1:2015/IEC61215:2021MQT21
                </Typography>
              )}
              {procedureData?.test_type === testTypes[6] && (
                // hail
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC61215:2016/IEC61215:2021 MQT17
                </Typography>
              )}
              {procedureData?.test_type === testTypes[7] && (
                // UVID Test
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC62804-1:2025
                </Typography>
              )}
              {procedureData?.test_type === testTypes[8] && (
                //  Humidity
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2016 MQT12/ IEC 61215:2021
                  MQT12/ IEC 61730:2016 MST52
                </Typography>
              )}
              {procedureData?.test_type === testTypes[9] && (
                // dml
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215-2:2021 MQT20/IEC TS 62782
                </Typography>
              )}
              {procedureData?.test_type === testTypes[10] && (
                // sml
                <Typography
                  variant="h6"
                  style={{ color: "red", fontWeight: "bold" }}
                >
                  According to standard IEC 61215:2016 MQT16/ IEC 61215:2021
                  MQT16
                </Typography>
              )}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers={true}>
          {procedureData?.supersede && (
            <Typography variant="body2" align="center">
              SUPERSEDED
            </Typography>
          )}

          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Typography variant="body1">
                Heading: {procedureData?.procedure_definition_name}
              </Typography>
              <Typography variant="body1">
                Disposition: {procedureData?.disposition_name}
              </Typography>
              <Typography variant="body1">
                Start Date/Time:{" "}
                {procedureData?.start_datetime
                  ? formatDate(procedureData.start_datetime)
                  : NOT_AVAILABLE}
              </Typography>
              <Typography variant="body1">
                End Date/Time:{" "}
                {procedureData?.end_datetime
                  ? formatDate(procedureData.end_datetime)
                  : NOT_AVAILABLE}
              </Typography>

              <Typography variant="body1" style={{ marginBottom: "10px" }}>
                Asset Name: {procedureData?.assets?.[0] || NOT_AVAILABLE} -{" "}
                <span
                  style={{
                    color: procedureData?.calibrated_during_test
                      ? "#36943a"
                      : "#d32f2f",
                    fontWeight: 600,
                  }}
                >
                  {procedureData?.calibrated_during_test
                    ? "Calibrated"
                    : "Not Calibrated"}
                </span>{" "}
              </Typography>

              <Typography variant="body1">
                Last Calibration Date:{" "}
                {procedureData?.asset_details?.last_calibrated_date
                  ? procedureData.asset_details.last_calibrated_date.substring(
                      0,
                      10,
                    )
                  : NOT_AVAILABLE}{" "}
              </Typography>
              <Typography variant="body1">
                Next Calibration Date:{" "}
                {procedureData?.asset_details?.next_calibration_date
                  ? procedureData.asset_details.next_calibration_date.substring(
                      0,
                      10,
                    )
                  : NOT_AVAILABLE}{" "}
              </Typography>
            </Grid>

            <Grid item xs={4} style={{ marginBottom: 18 }}>
              {procedureData?.test_type === testTypes[4] && (
                <>
                  <Typography variant="body1">
                    Light Exposure Method:{" "}
                    {procedureData?.light_exposure
                      ? procedureData.light_exposure
                      : NOT_AVAILABLE}
                  </Typography>
                  <Typography variant="body1">
                    Calibration Date:{" "}
                    {procedureData?.calibration_date
                      ? `${formatDate(procedureData.calibration_date).substring(0, 10)}`
                      : NOT_AVAILABLE}
                  </Typography>
                  <Typography variant="body1">
                    Irradiance Level:{" "}
                    {procedureData?.irradiance
                      ? `${procedureData.irradiance} W/m²`
                      : NOT_AVAILABLE}
                  </Typography>
                  <Typography variant="body1">
                    Average Temperature:{" "}
                    {procedureData?.average_temperature
                      ? `${procedureData.average_temperature} °C`
                      : NOT_AVAILABLE}
                  </Typography>
                  <Typography variant="body1">
                    Load Type:{" "}
                    {procedureData?.load_type
                      ? `${procedureData.load_type} Ω`
                      : NOT_AVAILABLE}
                  </Typography>
                  {procedureData?.load_type === "Fixed resistor" && (
                    <Typography variant="body1">
                      Fixed Resistor Value:{" "}
                      {procedureData?.fixed_resistor_value
                        ? `${procedureData?.fixed_resistor_value}Ω`
                        : "N/A"}
                    </Typography>
                  )}
                </>
              )}
              {procedureData?.test_type === testTypes[0] && (
                <DampHeatview procedureData={procedureData} />
              )}

              {procedureData?.test_type === testTypes[1] && (
                <ThermalCyclingView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[2] && (
                <CIDTestView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[3] && (
                <Letidview procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[5] && (
                <PIDTestView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[6] && (
                <HailTestView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[7] && (
                <UVIDTestView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[8] && (
                <HumidityFreezeTestView procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[9] && (
                <DMLview procedureData={procedureData} />
              )}
              {procedureData?.test_type === testTypes[10] && (
                <SMLview procedureData={procedureData} />
              )}
            </Grid>

            <Grid item xs={3}>
              <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={
                    isPdfLoading && viewingFileType === "run" ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : (
                      <VisibilityIcon />
                    )
                  }
                  onClick={() =>
                    handleOpenFileList(
                      procedureData?.run_files,
                      `Stress Run Files - ${name}`,
                    )
                  }
                  disabled={isPdfLoading}
                >
                  {viewingFileType === "run"
                    ? "Opening..."
                    : "View Stress Run File"}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  startIcon={
                    isPdfLoading && viewingFileType === "log" ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : (
                      <VisibilityIcon />
                    )
                  }
                  onClick={() =>
                    handleOpenFileList(
                      procedureData?.log_run_files,
                      `Stress Log Files - ${name}`,
                    )
                  }
                  disabled={isPdfLoading}
                >
                  {viewingFileType === "log"
                    ? "Opening..."
                    : "View Stress Log File"}
                </Button>
              </Box>
            </Grid>
          </Grid>

          {procedureResultData && (
            <LSDBCoreTable columns={columns} data={procedureResultData} />
          )}
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={1} />

            <Grid item xs={10} alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={flagChecked}
                    onChange={() => {
                      setFlagDialog(true);
                    }}
                    name="autoCheck"
                    color="primary"
                    disabled={getTheme()}
                  />
                }
                label="Final Result"
              />
            </Grid>
          </Grid>
        </DialogActions>
        <ConfirmationDialog
          id="stress-review-retest"
          keepMounted
          open={confirmationDialogRetestOpen}
          title="Stress Review Retest Confirmation"
          content="Are you sure that you want to retest this Stress Review?"
          onCancel={() => setConfirmationDialogRetestOpen(false)}
          onSubmit={() => submitVerification(false)}
        />
        <ConfirmationDialog
          id="stress-review-approve"
          keepMounted
          open={confirmationDialogApproveOpen}
          title="Stress Review Approval Confirmation"
          content="Are you sure that you want to approve this Stress Review?"
          onCancel={() => setConfirmationDialogApproveOpen(false)}
          onSubmit={() => submitVerification(true)}
        />

        <ConfirmationDialog
          id="flag-update"
          keepMounted
          open={flagDialog}
          title="Approval Confirmation"
          content="Please confirm whether the selected result is Correct?"
          onCancel={() => setFlagDialog(false)}
          onSubmit={() => submitFlagUpdate()}
        />
      </Dialog>

      {/* FILE LIST DIALOG AS A TABLE */}
      <Dialog
        open={fileListOpen}
        onClose={() => setFileListOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">{activeFileTitle}</Typography>
            <IconButton onClick={() => setFileListOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {activeFilesList.length > 0 ? (
            <MuiTable style={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>Filename</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Run-Name</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Upload Date
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Uploaded By
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: "bold" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activeFilesList.map((fileItem: any, index: number) => {
                  const isObj =
                    typeof fileItem === "object" && fileItem !== null;
                  const fileUrl = isObj
                    ? fileItem.stress_download_url
                    : fileItem;
                  const filename = isObj
                    ? fileItem.filename
                    : `File #${index + 1}`;

                  const runName = isObj
                    ? fileItem["run_name "] ||
                      fileItem.run_name ||
                      procedureData?.procedure_definition_name ||
                      name ||
                      "N/A"
                    : procedureData?.procedure_definition_name || name || "N/A";

                  const uploadDate =
                    isObj && fileItem.run_date
                      ? formatDate(fileItem.run_date)
                      : procedureData?.start_datetime
                        ? formatDate(procedureData.start_datetime)
                        : "N/A";

                  const uploader =
                    isObj && fileItem.user
                      ? fileItem.user
                      : procedureData?.username || "System";
                  const fileKey = `file-${index}`;

                  const urlParts =
                    typeof fileUrl === "string" ? fileUrl.split("/") : [];
                  const fileId = urlParts[urlParts.length - 2] || index + 1;

                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography
                          variant="subtitle2"
                          style={{ fontWeight: 600 }}
                        >
                          {filename} (ID: {fileId})
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{runName}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{uploadDate}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{uploader}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          style={{ gap: 4 }}
                        >
                          {/* View Button */}
                          <Button
                            variant="outlined"
                            size="small"
                            color="primary"
                            startIcon={<VisibilityIcon />}
                            onClick={() => {
                              
                              handleViewFile(fileItem, fileKey);
                            }}
                          >
                            View
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </MuiTable>
          ) : (
            <Typography
              variant="body2"
              color="textSecondary"
              align="center"
              style={{ padding: 20 }}
            >
              No files found.
            </Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* PDF VIEWER DIALOG WITH DOWNLOAD BUTTON */}
      <Dialog
        open={pdfViewerOpen}
        onClose={handleClosePdfViewer}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: { height: "90vh", display: "flex", flexDirection: "column" },
        }}
      >
        <DialogTitle disableTypography style={{ padding: 0 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="16px 24px"
          >
            <Typography variant="h6">Run File Viewer</Typography>
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
              {activeViewingFile && (
                <IconButton
                  color="primary"
                  title="Download File"
                  disabled={downloadingRun === "pdf-viewer"}
                  onClick={() =>
                    handleDownload(activeViewingFile, "pdf-viewer")
                  }
                >
                  <FileDownloadIcon />
                </IconButton>
              )}
              <IconButton edge="end" onClick={handleClosePdfViewer}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, flexGrow: 1 }}>
          {isPdfLoading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              <CircularProgress />
              <Typography style={{ marginTop: 16, color: "#555" }}>
                Preparing your document. This might take a moment...
              </Typography>
            </Box>
          ) : pdfBlobUrl ? (
            <iframe
              src={pdfBlobUrl}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="PDF Viewer"
            />
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              <Typography color="error">No document loaded.</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
